export const getInitialEventData = () => ({
  participant_id: "",
  event_type: "",
  event_subtype: "",
  event_time: 0,
  period_number: 1,
  event_data: {},
});

export const getNextEventDataAfterSubmit = (currentEventData) => ({
  participant_id: "",
  event_type: "",
  event_subtype: "",
  event_time: (currentEventData?.event_time || 0) + 1,
  period_number: currentEventData?.period_number || 1,
  event_data: {},
});

export const buildEventPayload = (eventData) => ({
  participantId: parseInt(eventData.participant_id, 10),
  participantType: "user",
  eventTime: eventData.event_time,
  period: eventData.period_number,
  description: `${eventData.event_type} event`,
  ...eventData.event_data,
});
